export const emailFormat =
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;

export function emailAddressIsValid(string) {
  if (typeof string !== 'string') {
    return;
  }
  return string.match(emailFormat);
}
